import { Module } from '@nestjs/common'
import { SequelizeModule } from '@nestjs/sequelize'

import { PlataformaController } from './controllers/plataforma.controller'

import { CuentaModel } from './models/aplicacion.model'
import { PlataformaModel } from './models/plataforma.model'

import { WebhookAplicacionService } from './services/aplicacion.server.services'

@Module({
  controllers: [PlataformaController],
  imports: [SequelizeModule.forFeature([CuentaModel, PlataformaModel])],
  providers: [WebhookAplicacionService],
})
export class PlataformaServerModule {}
